import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { Http } from "@capacitor-community/http";
import qs from "qs";
import _ from "lodash";
import { toast } from "react-hot-toast";
import store from "../store";
import Cookies from "universal-cookie";
import constant from "./constant";
// import Routes from "./Routes";
// import { hide_loader, show_loader } from "../actions/app";
import { Geolocation } from "@capacitor/geolocation";
import { Device } from "@capacitor/device";

// import history from "browserHistory";
// import { HIDE_LOADER } from "actions/actionConstants";

const cookies = new Cookies();

const url_variants = (base_url = constant.BASE_URL.DEFAULT) => {
  const env_with_prefix = `REACT_APP_${base_url}`;
  return process.env?.[env_with_prefix];
};

const buildRequestUrl = (baseUrl, version, url) => {
  const normalizedBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const normalizedUrl = url.startsWith("/") ? url.slice(1) : url;
  return `${normalizedBase}v${version}.0/${normalizedUrl}`;
};

let utils = {
  request: async ({
    version = 1,
    token,
    headers = {},
    base_url = constant.BASE_URL.DEFAULT,
    show_error = true,
    ...rest
  }) => {
    const config = rest;
    const resolvedToken = token ?? utils.get_access_token();
    try {
      const API_URL = url_variants(base_url);
      const ownerId = utils._retrieveData(constant.OWNER_ID);
      const parentId = utils._retrieveData(constant.PARENT_ID);
      const typeOfOwner = utils._retrieveData(constant.TYPE_OF_OWNER);
      const typeOfOwnerId =
        typeOfOwner && typeof typeOfOwner === "object"
          ? typeOfOwner.id
          : typeOfOwner;
      const requestHeaders = {
        ...(resolvedToken && {
          Authorization: "Bearer " + resolvedToken,
        }),
        ...(ownerId && !headers["owner-id"] && {
          "owner-id": ownerId,
        }),
        ...(parentId && !headers["parent-id"] && {
          "parent-id": parentId,
        }),
        ...(typeOfOwnerId && !headers["type-of-owner"] && {
          "type-of-owner": typeOfOwnerId,
        }),
        "Content-Type": "application/json",
        ...headers,
      };

      if (Capacitor.isNativePlatform()) {
        const response = await Http.request({
          method: (config.method || "GET").toUpperCase(),
          url: buildRequestUrl(API_URL, version, config.url || ""),
          params: config.params || {},
          data: config.data ?? undefined,
          dataType: "json",
          headers: requestHeaders,
          connectTimeout: 3600 * 1000,
          readTimeout: 3600 * 1000,
        });
        if (response?.status >= 400) {
          const error = {
            status: response.status,
            data: response.data,
          };
          throw error;
        }
        return Promise.resolve(response.data);
      }

      const res = await axios.request({
        baseURL: API_URL + `v${version}.0/`,
        timeout: 3600 * 1000,
        headers: requestHeaders,
        ...config,
      });
      return Promise.resolve(res.data);
    } catch (error) {
      const errorStatus = error?.response?.status ?? error?.status;
      const errorData = error?.response?.data ?? error?.data;
      if (show_error && errorStatus !== 403) {
        toast.error(
          _.get(errorData, "message") ||
            _.get(errorData, "error.message") ||
            error?.message ||
            ""
        );
      }
      if (_.get(errorData, "statusCode") === 401) {
        const query_object = qs.parse(window.location.search.slice(1));
        utils._removeData(constant.AUTH_TOKEN);
        utils._removeData(constant.TYPE_OF_OWNER);
        utils._removeData(constant.OWNER_ID);
        utils._removeData(constant.PARENT_ID);
        utils._removeData(constant.SELECTED_BUSINESS);
        utils._removeData(constant.SELECTED_BUSINESS_ID);
        window.open(
          _.isEmpty(query_object?.shopify_token)
            ? "/login"
            : `/?shopify_token=${query_object?.shopify_token}&is_login=true`,
          "_self"
        );
      }
      if (errorStatus === 403) {
        // history.push(Routes.ACCESS_DENIED.path);
        // store.dispatch({
        //   type: HIDE_LOADER,
        // });
      }
      return Promise.reject(error);
    }
  },

  setCustomHeader: (headers) => {
    axios.defaults.headers.common = {
      ...axios.defaults.headers.common,
      ...headers,
    };
  },
  _storeData: (name, value) => {
    if (Capacitor.isNativePlatform()) {
      try {
        localStorage.setItem(name, JSON.stringify(value));
      } catch (error) {
        // ignore storage errors
      }
      return;
    }
    cookies.set(name, value, {
      path: "/",
      expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    });
  },
  _retrieveData: (name) => {
    if (Capacitor.isNativePlatform()) {
      try {
        const raw = localStorage.getItem(name);
        return raw ? JSON.parse(raw) : undefined;
      } catch (error) {
        return undefined;
      }
    }
    return cookies.get(name);
  },
  _removeData: (name) => {
    if (Capacitor.isNativePlatform()) {
      try {
        localStorage.removeItem(name);
      } catch (error) {
        // ignore storage errors
      }
      return;
    }
    return cookies.remove(name, { path: "/" });
  },
  setRequestAuthHeader: (accessToken, type) => {
    utils.setCustomHeader({
      Authorization: "Bearer " + accessToken,
      "type-of-owner": type.id,
    });

    utils._storeData(constant.TYPE_OF_OWNER, type);
    utils._storeData(constant.AUTH_TOKEN, accessToken);
  },
  setRequestAuthHeaderBusinessId: (businessId, parent_id) => {
    utils.setCustomHeader({
      "owner-id": businessId,
      "parent-id": parent_id,
    });
    utils._storeData(constant.OWNER_ID, businessId);
    utils._storeData(constant.PARENT_ID, parent_id);
  },

  logout: () => {
    axios.defaults.headers.common = {};
    utils._removeData(constant.AUTH_TOKEN);
    utils._removeData(constant.TYPE_OF_OWNER);
    utils._removeData(constant.OWNER_ID);
    utils._removeData(constant.SELECTED_BUSINESS);
    // utils._removeData(constant.NAME);
    // utils._removeData(constant.MOBILE);
    // utils._removeData(constant.USER_ID);
    utils._removeData(constant.USER_DETIALS);
    utils._removeData(constant.PARENT_ID);
    utils._removeData(constant.SELECTED_BUSINESS_ID);
    // window.location.replace("/login");
  },
  get_access_token: () => {
    return utils._retrieveData(constant.AUTH_TOKEN);
  },
  get_business_id: () => {
    return store.getState().app.selected_business_id;
  },
  format_currency: (number) => {
    return number.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  },
  downloadBlob: (content, filename, contentType) => {
    // Create a blob
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement("a");
    pom.href = url;
    pom.setAttribute("download", filename);
    pom.click();
  },
  dot_in_between_string: (string_name) => {
    if (string_name.length < 10) return string_name;
    const first_five = string_name.slice(0, 5);
    const last_five = string_name.slice(-5);
    return `${first_five}...${last_five}`;
  },
  convert_hex_to_rgba: (hexCode, opacity) => {
    let hex = hexCode.replace("#", "");

    if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r},${g},${b},${opacity / 100})`;
  },

  remove_null_and_empty_from_obj: (obj, acc = {}, removeEmpty = false) => {
    return Object.entries(obj)
      .filter(
        ([, val]) =>
          val !== null &&
          !(removeEmpty && typeof val === "string" && val.trim() == "")
      )
      .reduce((acc, [key, val]) => {
        const accumulator = val && Array.isArray(val) ? [] : {};
        acc[key] =
          val && typeof val === "object"
            ? utils.remove_null_and_empty_from_obj(
                val,
                accumulator,
                removeEmpty
              )
            : val;
        return acc;
      }, acc);
  },

  hexToRgba: (hex, opacity) => {
    hex = hex.replace("#", "");

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  },

  ondc_status_map: (status) => {
    const map_obj = {
      OUT_FOR_PICKUP: "Agent assigned",
      OUT_FOR_DELIVERY: "Out for delivery",
      DELIVERED: "Order delivered",
      PICKED_UP: "Order picked up",
      CREATED: "Pending",
      CANCELLED: "Cancelled",
      REACHED_PICKUP: "At pickup",
      REACHED_DELIVERY: "At delivery",
    };

    return map_obj[status];
  },
  generate_OTP: () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  },

  haversine_distance: (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in km
  },

  find_nearest_location: (filtered, currentLocation) => {
    let nearestLocation = null;
    let minDistance = Infinity;

    filtered.forEach((location) => {
      const distance = utils.haversine_distance(
        currentLocation.latitude,
        currentLocation.longitude,
        location?.exact_location?.latitude,
        location?.exact_location?.longitude
      );
      if (distance < minDistance) {
        minDistance = distance;
        nearestLocation = location;
      }
    });

    return nearestLocation;
  },

detectCountry: async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      const permissions = await Geolocation.requestPermissions();

      if (permissions?.location === "granted") {
        const coordinates = await Geolocation.getCurrentPosition({
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        });

        const lat = coordinates?.coords?.latitude;
        const lng = coordinates?.coords?.longitude;

        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${constant.GOOGLE_MAP_KEY}`
        );

        const data = await response.json();

        if (
          response.ok &&
          data?.status === "OK" &&
          data?.results?.length
        ) {
          for (const component of data.results[0].address_components) {
            if (component.types.includes("country")) {
              const countryCode = component.short_name.toLowerCase();

              const countryMap = {
                in: "india",
                id: "indonesia",
              };

              return countryMap[countryCode] || "india";
            }
          }
        }
      }
    } catch (error) {
      console.warn("Location-based country detection failed:", error);
    }
  }
  try {
    const languageResult = await Device.getLanguageCode();
    const language =
      typeof languageResult === "string"
        ? languageResult
        : languageResult?.value;

    if (language) {
      const langCode = language.split("-")[0].toLowerCase();

      const langToCountry = {
        en: "india",
        id: "indonesia",
        in: "indonesia",
      };

      return langToCountry[langCode] || "india";
    }
  } catch (error) {
    console.warn("Language detection failed:", error);
  }

  return "india";
},
};

export const detectPaytmMiniApp = () => {
  return (
    typeof window !== "undefined" &&
    (typeof window.JSBridge !== "undefined" ||
      navigator.userAgent.toLowerCase().includes("paytm"))
  );
};

export default utils;
